import { rem } from '@heathmont/moon-utils';
import { css } from 'styled-components';

const smallImageStyle = css`
  height: ${rem(104)} !important;
  border-radius: ${rem(4)};
`;

export default smallImageStyle;
